module.exports = __webpack_public_path__ + "static/img/settingIconwg.324c808.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setting/settingIconwg.svg
// module id = qKIU
// module chunks = 0